import * as tslib_1 from "tslib";
import * as auth from '../../auth/actions/auth.actions';
import * as menus from '../actions/menus.actions';
import { generateEntities, parseEntities } from '../../core/helpers/entities';
import { parseChain } from '../../core/helpers/utility';
import { getNewTtl } from '../../core/helpers/date';
var initialState = {
    error: null,
    items: {},
    activeMenuChain: [],
    activeMenuId: null,
    loading: false,
    loaded: false,
    menusTtl: null,
    megaMenuOpen: false
};
export function reducer(state, action) {
    if (state === void 0) { state = initialState; }
    var wrap;
    var generatedData;
    switch (action.type) {
        case menus.GET:
            return tslib_1.__assign({}, state, { loading: true, loaded: false });
        case menus.GET_SUCCESS:
            wrap = action.payload;
            generatedData = generateEntities(wrap, 'code');
            return tslib_1.__assign({}, state, { items: generatedData.entities, loaded: true, loading: false, menusTtl: getNewTtl() });
        case menus.GET_FAILED:
            return tslib_1.__assign({}, state, { error: action.payload, loaded: false, loading: false });
        case menus.NAVIGATE:
            return tslib_1.__assign({}, state, { activeMenuChain: parseChain(parseEntities(state.items), action.payload), activeMenuId: action.payload });
        case menus.TOGGLE_MEGA_MENU:
            return tslib_1.__assign({}, state, { megaMenuOpen: action.payload });
        case auth.LOGOUT:
            return initialState;
        default:
            return state;
    }
}
export var isLoading = function (state) { return state.loading; };
export var getMenuEntities = function (state) { return state && state.items; };
export var getActiveMenuItemId = function (state) { return state.activeMenuId; };
export var getActiveMenuChain = function (state) { return state.activeMenuChain; };
export var getError = function (state) { return state.error; };
export var isMenusTtlExpired = function (state) { return state.menusTtl === null || state.menusTtl < new Date(); };
export var isMegaMenuOpen = function (state) { return state.megaMenuOpen; };
